import React, { useState } from 'react';
import {
  Box,
  TextField,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';

const TimeTextField = ({ defaultHour = 4, defaultMinute = 0 }) => {
  const [hour, setHour] = useState(defaultHour);
  const [minute, setMinute] = useState(defaultMinute);

  const circularStep = (prev, min, max, up) => {
    const range = max - min + 1;
    const offset = prev - min;
    const next = up ? (offset + 1) % range : (offset - 1 + range) % range;
    return next + min;
  };

  const handleHourChange = (e) => {
    const val = parseInt(e.target.value.replace(/\D/g, ''), 10);
    if (!isNaN(val) && val >= 0 && val <= 9) setHour(val); // 0 - 23
  };

  const stepHour = (up) => {
    //setHour((prev) => (up ? (prev + 1) % 24 : (prev - 1 + 24) % 24));
    setHour((prev) => circularStep(prev, 0, 9, up));
  };

  const handleMinuteChange = (e) => {
    const val = parseInt(e.target.value.replace(/\D/g, ''), 10);
    if (!isNaN(val) && val >= 0 && val <= 59) setMinute(val);
  };

  const stepMinute = (up) => {
    const step = 15;
    setMinute((prev) => (up ? (prev + step) % 60 : (prev - step + 60) % 60));
  };

  const commonSx = {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    width: '65px',
    pr: 0, // remove padding-right
    mr: 0, // remove margin-right
    '& .MuiInputBase-root': {
      pr: 0,
      mr: 0,
    },
  };

  const arrowBoxSx = {
    display: 'flex',
    flexDirection: 'column',
    m: 0,
    p: 0,
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Box>
        <TextField
          label="Giờ"
          type="number"
          variant="outlined"
          value={hour.toString().padStart(2, '0')}
          onChange={handleHourChange}
          inputProps={{ min: 0, max: 23 }}
          sx={commonSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ m: 0 }}>
                <Box sx={arrowBoxSx}>
                  <IconButton
                    onClick={() => stepHour(true)}
                    sx={{ p: 0.5, height: 28, width: 28 }} // bigger button
                  >
                    <ArrowDropUp sx={{ fontSize: 28 }} />
                  </IconButton>
                  <IconButton
                    onClick={() => stepHour(false)}
                    sx={{ p: 0.5, height: 28, width: 28 }}
                  >
                    <ArrowDropDown sx={{ fontSize: 28 }} />
                  </IconButton>
                </Box>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box>
        <TextField
          label="Phút"
          type="number"
          variant="outlined"
          value={minute.toString().padStart(2, '0')}
          onChange={handleMinuteChange}
          inputProps={{ min: 0, max: 59 }}
          sx={commonSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ m: 0 }}>
                <Box sx={arrowBoxSx}>
                  <IconButton
                    onClick={() => stepMinute(true)}
                    sx={{ p: 0.5, height: 30, width: 30 }} // bigger button
                  >
                    <ArrowDropUp sx={{ fontSize: 30 }} />
                  </IconButton>
                  <IconButton
                    onClick={() => stepMinute(false)}
                    sx={{ p: 0.5, height: 30, width: 30 }}
                  >
                    <ArrowDropDown sx={{ fontSize: 30 }} />
                  </IconButton>
                </Box>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
};

export default TimeTextField;
